import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { RefreshTaskType } from '~src/ts/ServerApi/requests/CreateSelfServiceScheduleExtractTasksRequest';

export interface PropsForCreateExtractTaksRunNowTab {
  close: (result?: RefreshTaskType) => void;
  disableIncremental: boolean;
  prompt: string;
}

export function CreateExtractTaskRunNowTab(props: PropsForCreateExtractTaksRunNowTab) {
  const paddingBottom = cssClass('run-now', 'pad-bottom', { paddingBottom: 12 });
  return <>
    <div className={paddingBottom}>{props.prompt}</div>
    <DialogFooterButtonsWidget
      buttons={[
        {
          handleClick: () => props.close(),
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: 'footer-cancel'
        },
        {
          handleClick: () => props.close('IncrementExtract'),
          buttonType: ButtonType.Primary,
          disabled: props.disableIncremental,
          children: Messages.refreshRunNowConfirmIncrementalButton(),
          testId: 'footer-confirm-incremental',
        },
        {
          handleClick: () => props.close('RefreshExtract'),
          buttonType: ButtonType.Primary,
          children: Messages.refreshRunNowConfirmFullButton(),
          testId: 'footer-confirm-full',
        },
      ]}
      testId='run-now-dialog-footer'
    />
  </>;
}